import React from "react";
import {useAppSelector} from "../../../store/hooks";
import {selectProfile} from "../../../ClientManagement/ClientProfile/activeProfileSlice";
import {ActivatePortfolioReserveSwitch, LabelPosition} from "./ActivatePortfolioReserveSwitch";
import { selectIsNationalSampleAdmin } from "src/Authorization/nationalSampleAdminSlice";

export interface ProfileAwareActivatePortfolioReserveSwitchProps {
    className?: string;
    labelPosition: LabelPosition;
    onTogglePortfolioReserve?: (activePortfolioReserve: boolean, profileId: string, dispatch: any) => void
}

export const ProfileAwareActivatePortfolioReserveSwitch = (props: ProfileAwareActivatePortfolioReserveSwitchProps) => {
    const profileOrProposal = useAppSelector(selectProfile);
    const isNationalSampleAdmin = useAppSelector(selectIsNationalSampleAdmin);
    
    const navDrawer = props.className === "nav-drawer__separator paddingleft-5" ? false : true;

    return (
        <ActivatePortfolioReserveSwitch
            activePortfolioReserve={profileOrProposal.activePortfolioReserve}
            onTogglePortfolioReserve={props.onTogglePortfolioReserve}
            showModal={navDrawer}
            isArchived={!profileOrProposal.activeClient}
            isNationalSample={profileOrProposal.isNationalSample}
            isNationalSampleAdmin={isNationalSampleAdmin}
            {...props}
        />
    )
}